import React from 'react';
import ReactDOM from 'react-dom/client';
// Ж8: Bootstrap се зарежда ЛОКАЛНО, а не от външен CDN. Три причини: публичната
// страница /p/:token се отваря от външни хора и всяко зареждане пращаше техния
// IP към чужд сървър; при блокиран или паднал CDN сайтът оставаше без стилове;
// и отпада едно външно закъснение. Версията е същата (5.3.0-alpha3), така че
// видът не се променя. Импортът е ПРЕДИ App, за да може global.css да го
// надписва. bundle-ът включва Popper — нужен е за падащите менюта и модалите.
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from 'react-router-dom'
import {ErrorBoundary} from './components/common/ErrorBoundary';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter basename="/farmers">
        <ErrorBoundary>
            <App />
        </ErrorBoundary>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
